import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";

function Newsletter_39() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter December 2025
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            COP30 Advances Climate Cooperation and Forest Protection Efforts.
          </title>
          <meta
            name="description"
            content="COP30 in Belém marked an important moment for global climate action as countries met in the Amazon for the first time to focus on practical measures that support long term climate goals."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          COP30 Advances Climate Cooperation and Forest Protection Efforts.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Dec_2025_1.webp")}
            alt="COP30 Advances Climate Cooperation and Forest Protection Efforts."
            loading="lazy"
          />
        </figure>
        <p>
          COP30 in Belém marked an important moment for global climate action as
          countries met in the Amazon for the first time to focus on practical
          measures that support long term climate goals. The summit prioritised
          clearer implementation pathways, nature focused solutions and stronger
          coordination across nations. With nearly thirty decisions adopted,
          COP30 offered a structured approach to climate finance, adaptation and
          collaboration that supports countries in turning commitments into
          measurable progress.
        </p>
        <p>
          A key achievement was the launch of the Tropical Forests Forever
          Facility with initial pledges of about 6.7 billion United States
          dollars. This initiative provides performance based finance to
          countries that protect tropical forests and allocates a dedicated
          share of funds to Indigenous and local communities. The facility
          promotes conservation, biodiversity and sustainable land management by
          linking financial support to verified environmental outcomes
        </p>
        <p>
          The summit also advanced global adaptation planning. Countries agreed
          to significantly increase adaptation finance by 2035 and adopted
          global indicators that will improve monitoring and reporting. These
          steps give governments clearer guidance to strengthen resilience,
          enhance climate readiness and support coordinated action ahead of
          future climate discussions.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The outcomes of COP30 are expected to influence the global economy
            by directing capital toward low carbon growth, nature based
            solutions and climate resilient infrastructure. The expansion of
            forest finance can reshape investment flows in agriculture, land use
            and supply chains, while higher adaptation funding can lower long
            term climate risk for financial markets. Together, these shifts
            encourage stable investment environments, reduce exposure to climate
            related losses and support more predictable pathways for sustainable
            economic development.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Hong Kong Issues Multi-Currency Digital Green Bond to Advance
          Sustainable Investment.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/Dec_2025_2.webp")}
              alt="Hong Kong Issues Multi-Currency Digital Green Bond to Advance Sustainable Investment."
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          Hong Kong has reinforced its role as a sustainable finance hub with a
          new multi-currency digital green bond issuance of about HK$10 billion
          under the Government Sustainable Bond Programme. This third
          transaction in the tokenisation series was offered in Hong Kong
          dollars, Renminbi, US dollars and euro and drew subscriptions of more
          than HK$130 billion from a broad range of global institutional
          investors. It is currently the largest digital bond deal globally,
          building on earlier tokenised green bond offerings in 2023 and 2024.
        </p>
        <p>
          Issued in digitally native form on a blockchain-based platform
          operated through the Central Moneymarkets Unit, the bonds link
          directly to Euroclear and Clearstream for clearing and settlement. For
          Hong Kong dollar and Renminbi tranches, tokenised central bank money
          in e-HKD and e-CNY was used in the primary settlement process, cutting
          settlement time, lowering costs and reducing counterparty risk. The
          deal also uses Digital Token Identifiers and the Bond Data Taxonomy to
          improve interoperability across digital and traditional market
          infrastructures.
        </p>
        <p>
          Proceeds will finance eligible public projects in areas such as clean
          transport, green buildings and climate adaptation, supporting Hong
          Kong’s transition toward carbon neutrality and greater climate
          resilience.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The expansion of digital green bonds offers corporates clearer
            capital pathways for long-term sustainability goals. Tokenised
            structures reduce settlement friction, strengthen auditability of
            environmental claims and improve access to diversified global
            investors. The integration of real-time data, interoperable
            standards and programmable workflows helps firms align financing
            with ESG targets more precisely.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Singapore Launches First Nationwide Levy to Fund Sustainable Aviation
          Fuel.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Dec_2025_3.webp")}
            alt="Singapore Launches First Nationwide Levy to Fund Sustainable Aviation Fuel"
            loading="lazy"
          />
        </figure>
        <p>
          Singapore will introduce a Sustainable Aviation Fuel (SAF) levy on all
          passengers, cargo and business aviation flights departing the country,
          with charges applied to tickets sold from April 2026 for flights from
          October 2026. The levy will range from S$1 for a short-haul economy
          ticket to S$41.60 for long-haul premium cabins, varying by distance
          and class of travel. Revenue will be channelled into a statutory SAF
          fund dedicated to purchasing SAF and associated environmental
          attributes, as well as certification, blending and delivery costs.
        </p>
        <p>
          The measure operationalises Singapore’s Sustainable Air Hub Blueprint,
          which requires all departing flights to use SAF starting at a 1% blend
          in 2026, rising to 3–5% by 2030, subject to global supply. SAF is
          expected to deliver nearly two thirds of the emissions reductions
          needed for the aviation sector to reach net zero by 2050, reflecting
          its central role in long-term decarbonisation plans.
        </p>
        <p>
          By explicitly pricing the cost of cleaner fuel into air travel,
          Singapore becomes the first state to impose a nationwide SAF levy,
          setting a reference point for other hubs under pressure to align with
          global climate goals. The approach seeks to keep individual ticket
          increases relatively modest while sending a clear demand signal to SAF
          producers, anchoring future production capacity in Asia and
          reinforcing Singapore’s positioning as a competitive yet
          carbon-constrained aviation hub.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Singapore’s SAF levy signals a shift toward cleaner aviation
            economics, pushing airlines to align costs with decarbonisation
            requirements. Carriers will need stronger fuel-efficiency
            strategies, long-term SAF procurement contracts and tighter
            integration of emissions data into financial planning. The levy also
            accelerates pressure on fleet renewal, operational optimisation and
            collaboration with fuel suppliers. Airlines that build early SAF
            resilience and anticipate rising carbon-linked costs will be better
            positioned as sustainability becomes a defining market expectation.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Global Investors Elevate Sustainable Strategies in Capital Allocation.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Dec_2025_4.webp")}
            alt="Global Investors Elevate Sustainable Strategies in Capital Allocation."
            loading="lazy"
          />
        </figure>
        <p>
          A global survey by a leading financial institution, conducted with a
          leading survey company, finds that more than four in five investors
          expect to increase allocations to sustainable strategies within two
          years. Around 86% of asset owners and 80% of asset managers foresee a
          higher share of assets in sustainable funds, confirming that ESG
          investing is a core driver of capital allocation.
        </p>
        <p>
          The research also shows that sustainable capabilities increasingly
          determine manager selection. Ninety percent of asset owners and nine
          in ten asset managers regard sustainable products as a key
          differentiator when awarding or retaining mandates, and most asset
          owners expect external managers to have a sustainable investing
          policy. Priority themes include renewable energy, energy efficiency,
          and climate adaptation, with climate resilience integrated into
          risk-return models.
        </p>
        <p>
          Despite this momentum, investors report obstacles. Concerns about ESG
          data quality, shifting regulation, and political uncertainty are
          intensifying. Without more consistent disclosure, reliable data, and
          policy frameworks, capital may not flow at the speed or scale needed
          to support a low-carbon, climate-resilient global economy.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Strengthening sustainable investing helps companies sharpen
            strategy, access more resilient capital, and stay aligned with
            evolving global expectations. When investors prioritize
            sustainability, firms gain clearer signals on where to innovate, how
            to manage long term risks, and which practices build market trust.
            This shift pushes companies to integrate climate and social metrics
            into core decision making, creating a tighter link between
            responsible operations and competitive advantage.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          EU Unveils New Sustainable and Transition Fund Categories to
          Strengthen ESG Clarity.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Dec_2025_5.webp")}
            alt="EU Unveils New Sustainable and Transition Fund Categories to Strengthen ESG Clarity."
            loading="lazy"
          />
        </figure>

        <p>
          The European Commission has proposed a major overhaul of the
          Sustainable Finance Disclosure Regulation (SFDR) to address
          complexity, inconsistent practices and the widespread use of Article 8
          and 9 as de facto labels. The reform introduces three voluntary
          product categories for financial products making ESG claims:
          “Sustainable,” “Transition,” and “ESG Basics.” Each must allocate at
          least 70% of its portfolio to investments aligned with the stated
          sustainability strategy and comply with common exclusion rules,
          including restrictions on coal-related activities and breaches of
          international norms, in order to curb greenwashing and improve
          comparability for investors.
        </p>
        <p>
          The “Sustainable” category targets products with high environmental or
          social ambition and excludes all fossil fuel activities, while
          “Transition” products support companies and projects on credible
          decarbonisation or improvement pathways and apply somewhat less
          stringent exclusions. “ESG Basics” applies where ESG is integrated
          beyond risk management but objectives are less ambitious, with
          mandatory social and coal-related exclusions. ESG claims in product
          names and marketing will be reserved for categorised products,
          reinforcing market discipline.
        </p>
        <p>
          The proposal also streamlines disclosures by repealing current
          regulatory technical standards, significantly shortening templates and
          eliminating certain entity-level principal adverse impact reporting
          obligations, particularly for larger market participants. This
          simplification is intended to cut compliance costs while strengthening
          the EU’s sustainable finance framework, supporting the EU Taxonomy and
          broader Green Deal objectives. If adopted, the new regime is expected
          to apply after an 18-month transition, with implementation currently
          projected around 2028.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The revised framework will push companies toward sharper
            sustainability performance and clearer evidence of progress. Firms
            will need to substantiate transition plans, tighten emissions
            reporting, and align capital allocation with credible improvement
            pathways. Superficial ESG claims will lose traction as investors
            rely on stricter fund categories that reward measurable outcomes.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_39;
